import { BrandColors } from '../theme';

export const carouselTokens = {
    root: {
        transitionDuration: '0.3s',
    },
    content: {
        gap: '0.75rem',
    },
    indicatorList: {
        padding: '0.75rem',
        gap: '0.5rem',
    },
    indicator: {
        width: '0.5rem',
        height: '0.5rem',
        borderRadius: '9999px',
        focusRing: {
            width: '0',
            style: 'none',
            color: 'transparent',
            offset: '0',
            shadow: 'none',
        },
    },
    colorScheme: {
        light: {
            indicator: {
                background: BrandColors.gray[300],
                hoverBackground: BrandColors.gray[500],
                activeBackground: BrandColors.primary[500],
            },
        },
        dark: {
            indicator: {
                background: BrandColors.gray[600],
                hoverBackground: BrandColors.gray[500],
                activeBackground: BrandColors.primary[500],
            },
        },
    },
};
